import { render, staticRenderFns } from "./ChooseRequestTypeStudent.vue?vue&type=template&id=1050c7ae"
import script from "./ChooseRequestTypeStudent.vue?vue&type=script&lang=js"
export * from "./ChooseRequestTypeStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports